import React, { useEffect, useState } from "react";
import { Loader } from "../../common/components/Loader/Loader";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { useTransportOrderStore } from "./store/TransportOrderStore";
import { ColumnItem } from "../../common/models/table";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { TransportOrderService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { ActionsKey } from "../../common/models/Actions";
import { CustomDrawer } from "../../common/components/Drawer/CustomDrawer";
import { TransportOrderForm } from "./components/TransportOrderForm";
import { useQueryTransportOrderState } from "./core/_hooks";
import { DetailsOt } from "./components/DetailsOt";
import { getStatusTag } from "./components/CustomTag";
import { API_URLs } from "../../utilities/API_URLs";
import { isUndefined } from "util";
import { Tag } from "antd";

export const TransportOrderList = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);
  const [isShowDrawerDetails, setIsShowDrawerDetails] =
    useState<boolean>(false);

  const {
    actioned,
    list,
    pageState,
    resetPageState,
    setActioned,
    setPageState,
    totalItems,
    setList,
  } = useTransportOrderStore();

  const { data: OTState, isLoading: OtStateLoader } =
    useQueryTransportOrderState();

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      show: true,
      searchKey: "reference",
      searchType: "text",

      // render: (state: any) => {
      //   return (
      //     <div className="h-100 w-100 d-flex align-items-center justify-content-center">
      //       <span>{state?.uniqueIdentifier}</span>
      //     </div>
      //   );
      // },
    },
    {
      key: "customer",
      title: "Client",
      dataIndex: "customer",
      show: true,
      searchType: "select",
      selectUri: API_URLs.settings.customers.getCustomerSelect,
      selectParams: {
        customerCategory: "OTHER",
      },
      searchKey: "customer",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "storageLoad",
      title: "Conteneur",
      dataIndex: "storageLoad",
      show: true,
      searchType: "text",
      searchKey: "storageLoad.uniqueIdentifierLoad",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.uniqueIdentifierLoad}</span>
          </div>
        );
      },
    },
    {
      key: "transportOrderState",
      title: "Status",
      dataIndex: "transportOrderState",
      show: true,
      searchType: "select",
      searchKey: "transportOrderState",
      nestedKey: "transportOrderState",
      isLoading: OtStateLoader,
      searchOptions: OTState,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{getStatusTag(state?.id, state?.name)}</span>
          </div>
        );
      },
    },
    {
      key: "createdAt",
      title: "Date de création",
      dataIndex: "createdAt",
      show: true,
    },
    {
      key: "emptyTCrecoveryDate",
      title: "Date de réstitution du conteneur vide",
      dataIndex: "emptyTCrecoveryDate",
      show: true,
    },
    {
      key: "restitutionControl",
      title: "Date d'arrivée effective",
      dataIndex: "restitutionControl",
      show: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.createdAt}</span>
          </div>
        );
      }
    },
    {
      key: "containerRestitutionDelay",
      title: "Écart de restitution",
      dataIndex: "containerRestitutionDelay",
      show: true,
      render: (state: any) => {
        if (!state?.interval) {
          return (
            <div className="h-100 w-100 d-flex align-items-center justify-content-center">
              <span>-</span>
            </div>
          );
        }
      
        const isLate = state.isLate;
        const label = isLate
          ? `En retard de ${state.interval}`
          : `En avance de ${state.interval}`;
      
        const color = isLate ? "red" : "green";
      
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <Tag color={color}>{label}</Tag>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchAllOrderTransport({
      ...pageState,
    });

    return () => {
      setActioned({
        action: "no",
        data: null,
      });
    };
  }, [pageState]);

  useEffect(() => {
    if (!isShowDrawer) {
      setActioned({
        action: "no",
        data: null,
      });
    }
  }, [isShowDrawer]);
  const fetchAllOrderTransport = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await TransportOrderService.getAllTransport({
        ...params,
      });
      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onShowDrawerHandler = () => {
    setIsShowDrawer((prev: boolean) => !prev);
  };

  const onShowDrawerDetailHandler = () => {
    setIsShowDrawerDetails((prev: boolean) => !prev);
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    // if (action === "update") {
    // }
    getOne(item?.id, action);
  };
  const getOne = async (id: number, action: ActionsKey) => {
    try {
      setIsLoading(true);
      const res = await TransportOrderService.getOneTransport(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      if (action === "update") {
        onShowDrawerHandler();
      } else if (action === "read") {
        onShowDrawerDetailHandler();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowDrawerHandler();
  };

  const onClickOnAdd = () => {
    onShowDrawerHandler();
  };

  const onRefetchData = () => {
    fetchAllOrderTransport({
      ...pageState,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <TitleHeader title="Transport" isEnableAdd onClickOnAdd={onClickOnAdd} />
      <div className="mt-4">
        <LFTableV3
          columns={cols}
          data={list}
          params={pageState}
          onAction={onActionClick}
          isCanEdit={() => true}
          isCanDelete={() => false}
          isCanShow={() => true}
          onSearch={handleSetParams}
          onSort={handleSetParams}
          onResetSearch={resetPageState}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>

      {isShowDrawer ? (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={onShowDrawerHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <TransportOrderForm
            onFinish={onFinishAction}
            onRefetch={onRefetchData}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
      {isShowDrawerDetails ? (
        <CustomDrawer
          isOpen={isShowDrawerDetails}
          onClose={onShowDrawerDetailHandler}
          title={"Détails"}
          width={"75%"}
        >
          <DetailsOt initialValue={actioned?.data} />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
